import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, isRef as _isRef, withCtx as _withCtx } from "vue"

import ShrinkWrap from './shrink-wrap.vue'
import ItemInfo from './item-info.vue'
import type { ItemInfoProps } from './item-info.vue'
import { ref, withDefaults, computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'apply-info',
  props: {
    infoArr: null
  },
  setup(__props: any) {

const props = __props as { infoArr: Array<ItemInfoProps> };


let infoArr = computed(() => props.infoArr)
let isShrink = ref(true)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ShrinkWrap, {
      title: "申请说明",
      isShrink: _unref(isShrink),
      "onUpdate:isShrink": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isShrink) ? (isShrink).value = $event : isShrink = $event)),
      class: "shrink"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(ItemInfo, _mergeProps(_unref(infoArr)[0], {
            isRequiredBottom: !_unref(isShrink)
          }), null, 16, ["isRequiredBottom"]),
          _withDirectives(_createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(infoArr).slice(1), (item, index) => {
              return (_openBlock(), _createBlock(ItemInfo, _mergeProps(item, { key: index }), null, 16))
            }), 128))
          ], 512), [
            [_vShow, !_unref(isShrink)]
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShrink"])
  ]))
}
}

})